export default __webpack_public_path__ + "75c1825c42c7e0860211a55daa7171d5.png";